import LoopWinsMediator from "ags/mediators/loop-wins-mediator";
import Mediators from "ags/mediators/mediators";
import { SignalBinding } from "signals";
import betModel from "slotworks/model/bets/bet-model";
import { Services } from "slotworks/services/services";
import SmartUIFlags, { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import State from "slotworks/state-machine/states/state";
import AnimateWinsMediator from "../mediators/animate-wins-mediator";

export default class GameiomPostFreespinLoopWins extends State {

    protected animateWinsMediator: AnimateWinsMediator;
    private loopWinsMediator: LoopWinsMediator;

    private signalBindings: SignalBinding[] = [];

    public onEnter() {
        SmartUIFlags.set(SmartUIFlag.IDLE, true);

        this.animateWinsMediator = new AnimateWinsMediator();
        this.animateWinsMediator.animateWinningSymbols();
        this.loopWinsMediator = new Mediators.LoopWinsMediatorType();

        this.signalBindings.push(betModel.onCreditSizeChanged.add(() => this.onComplete()));
        this.signalBindings.push(betModel.onCreditPerLineChanged.add(() => this.onComplete()));

        this.loopWins();
    }

    public onSkip() {
        this.skip();
    }

    public onExit() {
        SmartUIFlags.set(SmartUIFlag.IDLE, false);

        this.animateWinsMediator.end();
        this.loopWinsMediator.end().execute();

        for (const binding of this.signalBindings) {
            binding.detach();
        }
        this.signalBindings = [];
    }

    public onComplete() {

        Services.transaction.setTotalWin(0);

        this.complete();
    }

    private loopWins() {
        this.loopWinsMediator.start().then(() => this.loopWins());
    }
}
